import { useEffect, useRef, useState } from 'react';
import realtimeService from '../services/callcenterV2/realtimeService';

// =============================================================================
// useAutoBlockRealtime — hook que entrega eventos `security.auto_block.*` via
// Socket.IO e detecta queda de conexão para fallback de polling.
//
// Uso:
//   const { connected, lastEvent } = useAutoBlockRealtime((event) => {
//     // event: { type, payload, correlationId, tenantId, ... }
//   });
//
// Quando `connected === false` por > 10s o componente parent deve cair para
// polling. Quando voltar a `true`, pode parar o polling.
// =============================================================================

const STALE_THRESHOLD_MS = 10000;

export default function useAutoBlockRealtime(handler) {
  const [connected, setConnected] = useState(realtimeService.isConnected());
  const [lastEvent, setLastEvent] = useState(null);
  const handlerRef = useRef(handler);
  useEffect(() => { handlerRef.current = handler; }, [handler]);

  useEffect(() => {
    const unsubEvent = realtimeService.subscribeEvent('security.auto_block.', (event) => {
      setLastEvent(event);
      if (handlerRef.current) handlerRef.current(event);
    });
    const unsubConnected = realtimeService.subscribeConnected((c) => setConnected(c));
    return () => {
      unsubEvent();
      unsubConnected();
    };
  }, []);

  return { connected, lastEvent, staleThresholdMs: STALE_THRESHOLD_MS };
}
